import { Box } from "@mui/material";
import helenaLogo from "assets/helena-config-drawer-logo.svg";
import fireIcon from "assets/images/fire.webp";
import { HelenaAgentIcon } from "components";

// Placeholder and chosen assets. Each is listed by ID in
// .claude/projects/control-center/subscription/PRICING-BUILD-DECISIONS.md —
// swap the placeholder here once the real asset path is supplied.

/** PH-1 · MOST POPULAR flame — exported from Figma (64px source, shown at 16px). */
export const PopularBadgeIcon = () => (
  <Box
    component="img"
    src={fireIcon}
    alt=""
    aria-hidden="true"
    sx={{ display: "block", width: "16px", height: "16px" }}
  />
);

/** PH-2 · "AI agent actions" icon — HelenaAgentIcon (user's choice, 2026-10-26). */
export const AgentActionsIcon = HelenaAgentIcon;

/**
 * PH-3 · "Helena" icon — the Helena mark asset also imported by the Helena
 * config drawer (user's choice, 2026-10-26). 19px tall, measured from
 * design-screenshots/8-.png.
 */
export const HelenaCapabilityIcon = () => (
  <Box
    component="img"
    src={helenaLogo}
    alt=""
    sx={{ display: "block", height: "19px", width: "auto" }}
  />
);
